import * as React from "react";

const IconReorder: React.FC = () => {
    return <svg width="15px" height="24px" viewBox="0 0 15 24" fill="currentColor"version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <title>reorder icon</title>
    <g id="Project-List-–-Set" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="17-3_4D-–-My-List-:-Edit-:-ALT-VERSION" transform="translate(-159.000000, -661.000000)" fill="#888888">
            <g transform="translate(139.000000, 590.000000)">
                <g transform="translate(20.000000, 71.000000)">
                    <path d="M3,18 C4.65685425,18 6,19.3431458 6,21 C6,22.6568542 4.65685425,24 3,24 C1.34314575,24 0,22.6568542 0,21 C0,19.3431458 1.34314575,18 3,18 Z M12,18 C13.6568542,18 15,19.3431458 15,21 C15,22.6568542 13.6568542,24 12,24 C10.3431458,24 9,22.6568542 9,21 C9,19.3431458 10.3431458,18 12,18 Z M3,9 C4.65685425,9 6,10.3431458 6,12 C6,13.6568542 4.65685425,15 3,15 C1.34314575,15 0,13.6568542 0,12 C0,10.3431458 1.34314575,9 3,9 Z M12,9 C13.6568542,9 15,10.3431458 15,12 C15,13.6568542 13.6568542,15 12,15 C10.3431458,15 9,13.6568542 9,12 C9,10.3431458 10.3431458,9 12,9 Z M3,0 C4.65685425,0 6,1.34314575 6,3 C6,4.65685425 4.65685425,6 3,6 C1.34314575,6 0,4.65685425 0,3 C0,1.34314575 1.34314575,0 3,0 Z M12,0 C13.6568542,0 15,1.34314575 15,3 C15,4.65685425 13.6568542,6 12,6 C10.3431458,6 9,4.65685425 9,3 C9,1.34314575 10.3431458,0 12,0 Z"></path>
                </g>
            </g>
        </g>
    </g>
</svg>;
};

export default React.memo(IconReorder);
